import { render, staticRenderFns } from "./ClickAudio.vue?vue&type=template&id=72ce87c0"
import script from "./ClickAudio.vue?vue&type=script&lang=ts"
export * from "./ClickAudio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports